import { useState } from "react";
import "../../../assets/css/StudentShortDetails.css";
import { StudentListForHolidays } from "../../../Component/Modals/HolidaysStudentsList";

export const HolidayShortDetails = ({ selectedHoliday }) => {
    const [openStudentListModal, setOpenStudentListModal] = useState(false);
    const [modalType, setModalType] = useState(""); // "students" or "teachers"

    const getTotalDays = () => {
        if (!selectedHoliday?.fromDate || !selectedHoliday?.toDate) return "-";
        const from = new Date(selectedHoliday.fromDate);
        const to = new Date(selectedHoliday.toDate);

        const diffTime = to.getTime() - from.getTime();
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
        return diffDays > 0 ? diffDays : 0;
    };

    const handleViewList = (type) => {
        setModalType(type);
        setOpenStudentListModal(true);
    };

    return (
        <div>
            <div className="col-md-12">
                <p
                    style={{
                        background: "#F9F9F9",
                        padding: "16px",
                        borderRadius: "8px",
                        textAlign: "left",
                        fontWeight: 500,
                        color: "#222F3E",
                    }}
                >
                    HOLIDAY'S SHORT DETAILS:
                </p>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <div className="stu-pro">
                        <div className="stu-pro-inner">
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "start",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div>
                                    <h4
                                        className="fm-pr-hd"
                                        style={{ margin: 0, textTransform: "uppercase" }}
                                    >
                                        {selectedHoliday?.name}
                                    </h4>
                                </div>
                                <div>
                                    <p className="sd-p">Course</p>
                                    <p style={{ fontSize: "14px", textAlign: "left" }}>
                                        {selectedHoliday?.course}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div>
                            <p className="sd-p">Semester</p>
                            <p className="alg-l">{selectedHoliday?.semester}</p>
                        </div>

                        <div>
                            <p className="sd-p">Holiday Name</p>
                            <p className="alg-l">{selectedHoliday?.holidayName}</p>
                        </div>
                        <div>
                            <p className="sd-p">Holiday Type</p>
                            <p className="alg-l">{selectedHoliday?.holidayType}</p>
                        </div>

                        <div>
                            <p className="sd-p">From Date</p>
                            <p className="alg-l">{selectedHoliday?.fromDate}</p>
                        </div>

                        <div>
                            <p className="sd-p">To Date</p>
                            <p className="alg-l">{selectedHoliday?.toDate}</p>
                        </div>

                        <div>
                            <p className="sd-p">Total Days of Leave</p>
                            <p className="alg-l">{getTotalDays()}</p>
                        </div>
                        {/* 
                        <div>
                            <p className="sd-p">Apply For</p>
                            <p className="alg-l">{selectedHoliday?.applyFor}</p>
                        </div> */}
                        {(selectedHoliday?.applyFor === "Student Wise" ||
                            selectedHoliday?.applyFor === "Teacher Wise") && (
                                <div style={{ marginTop: "8px", display: "flex", flexDirection: "column", gap: "5px" }}>

                                    {/* Title for the list */}
                                    <div style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
                                        {selectedHoliday?.applyFor === "Student Wise"
                                            ? "List"
                                            : "List"}
                                    </div>

                                    {/* Buttons */}
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        {selectedHoliday?.students?.length > 0 && (
                                            <div style={{ marginBottom: "4px" }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    style={{
                                                        fontSize: "14px",
                                                        color: "#7F56DA",
                                                        textDecoration: "none",
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                    title={`View Student List (${selectedHoliday?.students?.length})`}
                                                    onClick={() => handleViewList("students")}
                                                >
                                                    View Students ({selectedHoliday?.students?.length})
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="#7F56DA"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        style={{ marginLeft: "5px" }}
                                                        title="View Student List"
                                                    >
                                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                        <circle cx="12" cy="12" r="3" />
                                                    </svg>
                                                </button>
                                            </div>
                                        )}

                                        {selectedHoliday?.teachers?.length > 0 && (
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    style={{
                                                        fontSize: "14px",
                                                        color: "#7F56DA",
                                                        textDecoration: "none",
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                    title={`View Teacher List (${selectedHoliday?.teachers?.length})`}
                                                    onClick={() => handleViewList("teachers")}
                                                >
                                                    View Teachers ({selectedHoliday?.teachers?.length})
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="18"
                                                        height="18"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="#7F56DA"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        style={{ marginLeft: "5px" }}
                                                        title="View Teacher List"
                                                    >
                                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                                        <circle cx="12" cy="12" r="3" />
                                                    </svg>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}



                    </div>
                </div>
            </div>

            {/* Modal */}
            <StudentListForHolidays
                isOpen={openStudentListModal}
                onClose={() => setOpenStudentListModal(false)}
                students={modalType === "students" ? selectedHoliday?.students || [] : []}
                teachers={modalType === "teachers" ? selectedHoliday?.teachers || [] : []}
            />
        </div>
    );
};
